<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>内容管理</a-breadcrumb-item>
    <a-breadcrumb-item>待入库</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 列表 -->
  <a-table class="table-view" :data-source="dataSource" :columns="columns" :row-key="record => record.id"
    :pagination="pagination" :loading="isLoading" @change="handleTableChange">
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 剧名 -->
      <template v-if="column.key === 'name'">
        <!-- <img class="cover-img" :src="$pub.CDN_URL(record.s_cover[0].url)" v-if="record && record.s_cover.length">
        <span class="cover-title">{{ record.remark_name }}</span> -->
        {{ record.name }}
      </template>
      <!-- 操作 -->
      <template v-if="column.key === 'operation'">
        <a class="operation-item" @click="touchInfo(record)">入库</a>
        <a-popconfirm title="确定要取消入库吗？" @confirm="touchCancel(record)">
          <a class="operation-item">取消入库</a>
        </a-popconfirm>
      </template>
    </template>
  </a-table>
  <!-- 基本信息 -->
  <BaseInfo ref="RefBaseInfo" @success="getList"></BaseInfo>
</template>

<script setup>
import { onBeforeMount, ref, reactive } from 'vue'
import { message } from 'ant-design-vue'
import BaseInfo from './components/BaseInfo'
import { getDramaUnList, cancelStorageDrama } from '@/api/appfront'

// 基本信息组件实例
let RefBaseInfo = ref(null)
// 加载
let isLoading = ref(false)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源（付费转化率、权重本期不做）
let columns = ref([
  {
    title: '剧名',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

// 钩子函数 - onBeforeMount
onBeforeMount(() => {
  getList()
})

// 分页处理
function handleTableChange(p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 获取数据
function getList() {
  isLoading.value = true
  const params = {
    in_storage: 0,
    page: pagination.current,
    page_size: pagination.pageSize,
    // 默认按 id 降序
    key: 'id',
    sort: 'desc'
  }
  getDramaUnList(params).then(res => {
    console.log(res);

    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  })
}

// 基本信息
function touchInfo(record) {
  RefBaseInfo.value.showDrawer(record)
}

// 取消入库
function touchCancel(record) {
  isLoading.value = true
  cancelStorageDrama({
    id: record.id
  }).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      message.success('取消成功')
      // 更新列表
      getList()
    } else {
      message.error(res.message || msg)
    }
  })
}

</script>

<style scoped>
.tool-view {
  display: flex;
  align-items: center;
  margin-top: 30px;
}

.table-view {
  margin-top: 30px;
}

.tool-title:not(:first-child) {
  margin-left: 16px;
}

.cover-img {
  display: inline-block;
  width: 40px;
  height: 40px;
}

.cover-title {
  margin-left: 10px;
}
</style>